import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useContext } from '@wordpress/element';
import { __experimentalToolbarContext as ToolbarContext, ToolbarGroup, __experimentalUseSlot as useSlot } from '@wordpress/components';
/**
 * Internal dependencies
 */

import groups from './groups';
export default function BlockControlsSlot(_ref) {
  let {
    group = 'default',
    ...props
  } = _ref;
  const accessibleToolbarState = useContext(ToolbarContext);
  const Slot = groups[group].Slot;
  const slot = useSlot(Slot.__unstableName);
  const hasFills = Boolean(slot.fills && slot.fills.length);

  if (!hasFills) {
    return null;
  }

  if (group === 'default') {
    return createElement(Slot, _extends({}, props, {
      bubblesVirtually: true,
      fillProps: accessibleToolbarState
    }));
  }

  return createElement(ToolbarGroup, null, createElement(Slot, _extends({}, props, {
    bubblesVirtually: true,
    fillProps: accessibleToolbarState
  })));
}
//# sourceMappingURL=slot.js.map